import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/profile/presentation-templates",
)({
	beforeLoad: () => {
		throw redirect({ to: "/settings/presentation-templates" });
	},
});
